/* tslint:disable */
/* eslint-disable */
/**
 * Hermes Console
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * ナビリポート
 * @export
 * @interface TripsReportsRow
 */
export interface TripsReportsRow {
    /**
     * 乗務日
     * @type {number}
     * @memberof TripsReportsRow
     */
    shiftDate?: number;
    /**
     * 営業所ID
     * @type {number}
     * @memberof TripsReportsRow
     */
    officeId?: number;
    /**
     * 営業所名称
     * @type {string}
     * @memberof TripsReportsRow
     */
    officeName?: string;
    /**
     * 乗務員ID
     * @type {number}
     * @memberof TripsReportsRow
     */
    driverId?: number;
    /**
     * 乗務員名
     * @type {string}
     * @memberof TripsReportsRow
     */
    driverName?: string;
    /**
     * 乗務員番号
     * @type {string}
     * @memberof TripsReportsRow
     */
    driverCode?: string;
    /**
     * 複数のログイン/ログアウトを乗務単位にまとめるためのID
     * @type {string}
     * @memberof TripsReportsRow
     */
    shiftId?: string;
    /**
     * 乗務時間
     * @type {number}
     * @memberof TripsReportsRow
     */
    shiftLenMin?: number;
    /**
     * 要指導
     * @type {string}
     * @memberof TripsReportsRow
     */
    needGuidance?: string;
    /**
     * 空車開始時刻(UTC, フォーマット '2023-05-02T04:13:18Z')
     * @type {string}
     * @memberof TripsReportsRow
     */
    unladenStartTs?: string;
    /**
     * 空車開始場所
     * @type {string}
     * @memberof TripsReportsRow
     */
    unladenStartCity?: string;
    /**
     * 乗車時刻
     * @type {string}
     * @memberof TripsReportsRow
     */
    boardingTs?: string;
    /**
     * 乗車場所
     * @type {string}
     * @memberof TripsReportsRow
     */
    boardingCity?: string;
    /**
     * 空車時間(秒)
     * @type {number}
     * @memberof TripsReportsRow
     */
    unladenSec?: number;
    /**
     * 配車一時停止時間(秒)
     * @type {number}
     * @memberof TripsReportsRow
     */
    pauseCarRequestSec?: number;
    /**
     * 走行時間
     * @type {number}
     * @memberof TripsReportsRow
     */
    handleTime?: number;
    /**
     * 乗車種別 (cruising/stand/go/tel/cancel_tel/homing/error)
     * @type {string}
     * @memberof TripsReportsRow
     */
    boardingType?: string;
    /**
     * ナビ停止時間(秒)
     * @type {number}
     * @memberof TripsReportsRow
     */
    naviOffSec?: number;
    /**
     * 離脱回数
     * @type {number}
     * @memberof TripsReportsRow
     */
    deviationCount?: number;
    /**
     * キャンセル回数
     * @type {number}
     * @memberof TripsReportsRow
     */
    goCancelCount?: number;
    /**
     * 下車時刻
     * @type {string}
     * @memberof TripsReportsRow
     */
    deliverTs?: string;
    /**
     * 下車場所
     * @type {string}
     * @memberof TripsReportsRow
     */
    deliverCity?: string;
    /**
     * ナビoffバツマーク
     * @type {number}
     * @memberof TripsReportsRow
     */
    isHermesOff?: number;
    /**
     * Goキャンセルバツマーク
     * @type {number}
     * @memberof TripsReportsRow
     */
    isGoCancel?: number;
    /**
     * 離脱バツマーク
     * @type {number}
     * @memberof TripsReportsRow
     */
    isDeviation?: number;
    /**
     * unladen trip shape
     * @type {object}
     * @memberof TripsReportsRow
     */
    unladenShape?: object;
    /**
     * navi trip shape
     * @type {object}
     * @memberof TripsReportsRow
     */
    naviShape?: object;
    /**
     * unladen start coords
     * @type {object}
     * @memberof TripsReportsRow
     */
    unladenStartLoc?: object;
    /**
     * deliver start coords
     * @type {object}
     * @memberof TripsReportsRow
     */
    deliverStartLoc?: object;
    /**
     * trip session id
     * @type {string}
     * @memberof TripsReportsRow
     */
    tripSessionId?: string;
    /**
     * ログイン(開局) 単位で発行されるID
     * @type {string}
     * @memberof TripsReportsRow
     */
    loginSessionId?: string;
}

export function TripsReportsRowFromJSON(json: any): TripsReportsRow {
    return TripsReportsRowFromJSONTyped(json, false);
}

export function TripsReportsRowFromJSONTyped(json: any, ignoreDiscriminator: boolean): TripsReportsRow {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'shiftDate': !exists(json, 'shift_date') ? undefined : json['shift_date'],
        'officeId': !exists(json, 'office_id') ? undefined : json['office_id'],
        'officeName': !exists(json, 'office_name') ? undefined : json['office_name'],
        'driverId': !exists(json, 'driver_id') ? undefined : json['driver_id'],
        'driverName': !exists(json, 'driver_name') ? undefined : json['driver_name'],
        'driverCode': !exists(json, 'driver_code') ? undefined : json['driver_code'],
        'shiftId': !exists(json, 'shift_id') ? undefined : json['shift_id'],
        'shiftLenMin': !exists(json, 'shift_len_min') ? undefined : json['shift_len_min'],
        'needGuidance': !exists(json, 'need_guidance') ? undefined : json['need_guidance'],
        'unladenStartTs': !exists(json, 'unladen_start_ts') ? undefined : json['unladen_start_ts'],
        'unladenStartCity': !exists(json, 'unladen_start_city') ? undefined : json['unladen_start_city'],
        'boardingTs': !exists(json, 'boarding_ts') ? undefined : json['boarding_ts'],
        'boardingCity': !exists(json, 'boarding_city') ? undefined : json['boarding_city'],
        'unladenSec': !exists(json, 'unladen_sec') ? undefined : json['unladen_sec'],
        'pauseCarRequestSec': !exists(json, 'pause_car_request_sec') ? undefined : json['pause_car_request_sec'],
        'handleTime': !exists(json, 'handle_time') ? undefined : json['handle_time'],
        'boardingType': !exists(json, 'boarding_type') ? undefined : json['boarding_type'],
        'naviOffSec': !exists(json, 'navi_off_sec') ? undefined : json['navi_off_sec'],
        'deviationCount': !exists(json, 'deviation_count') ? undefined : json['deviation_count'],
        'goCancelCount': !exists(json, 'go_cancel_count') ? undefined : json['go_cancel_count'],
        'deliverTs': !exists(json, 'deliver_ts') ? undefined : json['deliver_ts'],
        'deliverCity': !exists(json, 'deliver_city') ? undefined : json['deliver_city'],
        'isHermesOff': !exists(json, 'is_hermes_off') ? undefined : json['is_hermes_off'],
        'isGoCancel': !exists(json, 'is_go_cancel') ? undefined : json['is_go_cancel'],
        'isDeviation': !exists(json, 'is_deviation') ? undefined : json['is_deviation'],
        'unladenShape': !exists(json, 'unladen_shape') ? undefined : json['unladen_shape'],
        'naviShape': !exists(json, 'navi_shape') ? undefined : json['navi_shape'],
        'unladenStartLoc': !exists(json, 'unladen_start_loc') ? undefined : json['unladen_start_loc'],
        'deliverStartLoc': !exists(json, 'deliver_start_loc') ? undefined : json['deliver_start_loc'],
        'tripSessionId': !exists(json, 'trip_session_id') ? undefined : json['trip_session_id'],
        'loginSessionId': !exists(json, 'login_session_id') ? undefined : json['login_session_id'],
    };
}

export function TripsReportsRowToJSON(value?: TripsReportsRow | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'shift_date': value.shiftDate,
        'office_id': value.officeId,
        'office_name': value.officeName,
        'driver_id': value.driverId,
        'driver_name': value.driverName,
        'driver_code': value.driverCode,
        'shift_id': value.shiftId,
        'shift_len_min': value.shiftLenMin,
        'need_guidance': value.needGuidance,
        'unladen_start_ts': value.unladenStartTs,
        'unladen_start_city': value.unladenStartCity,
        'boarding_ts': value.boardingTs,
        'boarding_city': value.boardingCity,
        'unladen_sec': value.unladenSec,
        'pause_car_request_sec': value.pauseCarRequestSec,
        'handle_time': value.handleTime,
        'boarding_type': value.boardingType,
        'navi_off_sec': value.naviOffSec,
        'deviation_count': value.deviationCount,
        'go_cancel_count': value.goCancelCount,
        'deliver_ts': value.deliverTs,
        'deliver_city': value.deliverCity,
        'is_hermes_off': value.isHermesOff,
        'is_go_cancel': value.isGoCancel,
        'is_deviation': value.isDeviation,
        'unladen_shape': value.unladenShape,
        'navi_shape': value.naviShape,
        'unladen_start_loc': value.unladenStartLoc,
        'deliver_start_loc': value.deliverStartLoc,
        'trip_session_id': value.tripSessionId,
        'login_session_id': value.loginSessionId,
    };
}


